import { z } from "zod";
import { ageGroupVariationSchema } from "./ageGroupVariationSchema";

/**
 * Location program keys must NOT start with "g-".
 * That prefix is reserved for organization Shared Programs.
 */
export const locationProgramVariationSchema = ageGroupVariationSchema.extend({
  key: z
    .string()
    .min(1, "ID is required")
    .max(40, "ID cannot exceed 40 characters")
    .regex(/^[a-zA-Z0-9_-]+$/, "ID can only contain letters, numbers, underscores, and hyphens")
    .refine(
      (key) => !key.startsWith("g-"),
      "ID cannot start with 'g-'. That prefix is reserved for shared programs."
    ),
});

export type LocationProgramVariationFormData = z.infer<
  typeof locationProgramVariationSchema
>;

